import  * as actions from './action';

import {Map, fromJS} from 'immutable';

function SystemReducer (state = Map(), action) {
    switch (action.type) {
        case actions.SET_SYSTEM:
            return state.set('payload', fromJS(action.payload));
        default:
            return state;
    }
    return state;
}
export default SystemReducer;



// WEBPACK FOOTER //
// ./redux/model/system/reducer.js